import React, { lazy, Suspense, useEffect, useState } from 'react'
import CaseNewHead from './CaseNewHead'
import ApiRequest from '../../helper/ApiRequest';
import { ApiEndpoints } from '../../helper/ApiEndpoints';

const CaseNewCards = lazy(() => import("./CaseNewCards"));

const adminCaseListEndpoint = ApiEndpoints.newCase.adminCaseList;
export default function CaseNewList() {
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", adminCaseListEndpoint);
        const result = response.newcasestudys;
        setAllData(result);
      } catch (error) {
        console.log(error);
      }
    };

    dataFetch();
  }, []);

  const sortedData = Array.isArray(allData)
  ? [...allData].sort((a, b) => {
      if (a.rank == null) return 1;
      if (b.rank == null) return -1;
      return Number(a.rank) - Number(b.rank);
    })
  : [];

  return (
    <>
      <CaseNewHead />
      <Suspense fallback={null}>
        <CaseNewCards allData={sortedData} />
      </Suspense>
    </>
  )
}
